<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('users') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_user')"
        @click="$router.push({ name: 'createUser' })"
      />
    </div>

    <!--    <UserFilter-->
    <!--      :filter-params="userFilterParams"-->
    <!--      @change="$router.push({ name: 'users', query: { ...$event, page: 1 } })"-->
    <!--      @reset="resetUserFilters"-->
    <!--    />-->

    <BaseTableLoader :loading="!users">
      <UserTable
        :items="users"
        :pagination="userPagination"
        :loading="loadingUsers"
        :disabled-item-ids="disabledUserIds"
        @edit="$router.push({ name: 'editUser', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deleteUser"
        @impersonate="impersonateUser"
        @reset-password="resetPassword"
        @toggle-status="toggleUserStatus"
      />
    </BaseTableLoader>

    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UserTable from '../../components/UserTable.vue';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import BaseTableLoader from '../../components/base/BaseTableLoader';
// import UserFilter from '../../components/UserFilter';
import { getDefaultUserFilterParams } from '../../store/modules/user-module';

export default {
  name: 'Users',

  components: {
    // UserFilter,
    BaseTableLoader,
    BasePrimaryActionButton,
    UserTable,
  },

  created() {
    if (!this.users) {
      this.fetchUsers(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name === 'users' && from.name !== 'createUser' && from.name !== 'editUser') {
      // to avoid catching editUser and createUser routes that are children of this route
      this.fetchUsers(to.query);
    }
    next();
  },

  computed: mapState('users', [
    'users',
    'userPagination',
    'loadingUsers',
    'userFilterParams',
    'disabledUserIds',
  ]),

  methods: {
    ...mapActions('users', ['fetchUsers', 'deleteUser', 'resetPassword', 'toggleUserStatus']),

    ...mapActions('auth', ['impersonateUser']),

    onPageChange(page) {
      const query = { ...this.userFilterParams, page };
      this.$router.push({ name: 'users', query });
    },

    resetUserFilters() {
      this.$router.push({ name: 'users', query: getDefaultUserFilterParams() });
    },
  },
};
</script>
